import {
  dayDiff,
  formatAMPM,
  getMonthString,
  getWeekDayFullString,
} from 'common/support/dateHelper';
import { IntlShape } from 'react-intl';

const messages = {
  tonight: {
    id: 'date.tonight',
    description: 'tonight',
  },
  today: {
    id: 'date.today',
    description: 'today',
  },
  tomorrow: {
    id: 'date.tomorrow',
    description: 'tomorrow',
  },
  coming: {
    id: 'date.coming',
    description: 'coming',
  },
  ordinal: {
    id: 'date.ordinal',
    description: 'ordinal for date',
  },
  ttsAt: {
    id: 'textToSpeechHelper.at',
    description: 'TTS for at',
  },
};

export const formatDateWithSuffix = (date: Date): string | null => {
  try {
    const day = date.getDate();
    const j = day % 10;
    const k = day % 100;
    if (j === 1 && k !== 11) return `${day}st`;
    if (j === 2 && k !== 12) return `${day}nd`;
    if (j === 3 && k !== 13) return `${day}rd`;
    return `${day}th`;
  } catch {
    // no-op
  }
  return null;
};

const getUpcomingMessage = (date: Date, now: Date): { id: string; description: string } | null => {
  try {
    const diff = dayDiff(now, date);
    if (diff === 0)
      return date.getHours() > 15 ? messages.tonight : messages.today;
    if (diff === 1) return messages.tomorrow;
  } catch {
    // no-op
  }
  return null;
};

export const getUpcomingDate = (intl: IntlShape, date: Date, now: Date = new Date()): string => {
  const message = getUpcomingMessage(date, now);
  if (message) {
    return [
      intl.formatMessage(message),
      intl.formatMessage(messages.ttsAt),
      formatAMPM(intl, date),
    ].join(' ');
  }

  return [
    intl.formatMessage(messages.coming),
    getMonthString(intl, date),
    intl.formatMessage(messages.ordinal, { date: date.getDate() }),
  ].join(' ');
};

export const getUpcomingDay = (intl: IntlShape, date: Date, now: Date = new Date()) => {
  const message = getUpcomingMessage(date, now);
  if (message) return intl.formatMessage(message as Parameters<typeof intl.formatMessage>[0]);
  const weekDay = getWeekDayFullString(intl, date);
  return weekDay;
};
